import useSWR, { SWRResponse } from "swr";
import { IUseCustomerInfo } from "./types";
import commonSwrConfig from "@portal/hooks/commonSwrConfig";
import { ICustomerInfo } from "@portal/types/api/ICustomerInfo";
import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";
import useAdvisor from "../useAdvisor";

const useCustomerInfo: IUseCustomerInfo = () => {
  const { update } = useSession();
  const { isAdvisorAndNoImpersonation } = useAdvisor();

  const path = "/api/customer-info/";

  const { data, error, isLoading, mutate }: SWRResponse<ICustomerInfo, unknown> = useSWR(
    isAdvisorAndNoImpersonation ? null : path,
    commonFetcher<ICustomerInfo>,
    commonSwrConfig(update),
  );
  const response = { data, error, isLoading, mutate };

  return response;
};

export default useCustomerInfo;
